// extracted by mini-css-extract-plugin
export default {"login":"Login_login__jJiFM","boxInput":"Login_boxInput__dSMm2"};